import axios from "axios";
import { API_BASE } from "./config";

// Create axios instance with base configuration
const api = axios.create({
  baseURL: API_BASE,
});

// Request interceptor to add admin token to protected requests
api.interceptors.request.use(
  (config) => {
    // Add admin token for all API routes (admin panel always authenticates)
    const token = localStorage.getItem("adminToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Token expired or invalid, redirect to login
      localStorage.removeItem("adminToken");
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
